import { action, makeObservable, observable, runInAction } from 'mobx';
import { Maybe } from '../../core';
import { notifyError } from '../../services/notifications';
import { Store } from '../../store/store';
import { Message, StoreNode } from '../../store';
import { WindowState } from '../overlays/windowState';

export class DownloadJobSlidesWindowState
  extends StoreNode {

  readonly nodeType = 'DownloadJobSlidesWindow';

  constructor(store: Store) {
    super(store);
    makeObservable<this, 'windowListener'>(this, {
      isLoading: observable,
      downloadUrl: observable,
      submit: action,
      windowListener: action,
      open: action,
      close: action,
    });

    this.window.listen(
      this.windowListener);
  }

  readonly window = new WindowState(this.store);

  isLoading: boolean = false;
  downloadUrl: string | null = null;

  jobId: Maybe<string>;

  async submit() {
    if (!this.jobId) {
      notifyError(this, 'Could not download the slides for this video');
    }
    
    this.isLoading = true;

    const [res, err] = await this.store.apiService.getJob({ id: this.jobId! });

    if (err) {
      notifyError(this, 'Could not download the slides for this video');
      return this.handleSubmitFinally();
    }

    runInAction(() => {
      if (res?.getJob?.slideDeckUrl) {
        this.downloadUrl = res.getJob?.slideDeckUrl;
      } else {  
        notifyError(this, 'Could not download the slides for this video');
        this.handleSubmitFinally();
      }  
    });
  }

  handleSubmitFinally() {
    runInAction(() => {
      this.isLoading = false;
      this.downloadUrl = null;
      this.close();
    })
  }

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        this.close();
        break;
    }
  }

  open({ jobId }: { jobId: string }) {
    this.dispatch('Overlays', 'openWindow', { name: 'DownloadJobSlidesWindow' });

    this.jobId = jobId;
  }

  close() {
    this.jobId = null;

    this.emit('close');
    this.dispatch('Overlays', 'closeWindow');
  }
}